module.exports = __webpack_public_path__ + "img/no_nft.c6e1722e.png";